import React from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { Asterisk } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { OtpPasswordModalProps } from "./OtpPasswordModal.types.tsx";

import { GreenLabel, HeaderLabel, SubHeaderLabel } from "../../components/Labels.tsx";
import { ActionButton } from "../../components/Buttons.tsx";
import { useTheme } from "../../context/Theme.context.tsx";

const OtpPasswordModal: React.FC<OtpPasswordModalProps> = ({
  show,
  handleClose,
  otp,
  email,
  validated,
  isLoading,
  onChangeOtp,
  onSubmit,
  onResendCode,
}) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const spinnerVariant = theme === "dark" ? "light" : "dark";

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
      <Modal.Body>
        {isLoading ? (
          <div className="d-flex justify-content-center my-4">
            <Spinner variant={spinnerVariant} />
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-center mb-2">
              <Asterisk />
              <Asterisk />
              <Asterisk />
            </div>

            <HeaderLabel>{t("otpPasswordModal.title")}</HeaderLabel>

            <SubHeaderLabel>{t("otpPasswordModal.subtitle", { email })}</SubHeaderLabel>

            <Form noValidate validated={validated} onSubmit={onSubmit}>
              <Form.Group className="text-center mb-3">
                <OtpInput
                  value={otp}
                  onChange={onChangeOtp}
                  numInputs={6}
                  renderInput={(props) => (
                    <input
                      {...props}
                      required
                      style={{
                        width: "50px",
                        height: "50px",
                        textAlign: "center",
                        fontSize: "20px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        outline: validated && otp.length < 6 ? "2px solid #dc3545" : "none",
                      }}
                    />
                  )}
                  containerStyle={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                />

                {validated && otp.length < 6 && (
                  <div className="d-block">{t("otpPasswordModal.invalidCode")}</div>
                )}
              </Form.Group>

              <GreenLabel onClick={onResendCode} textAlign="center">
                {t("otpPasswordModal.resendCode")}
              </GreenLabel>

              <div className="d-flex justify-content-around align-items-center buttonsContainer">
                <GreenLabel onClick={handleClose} margin="0">
                  {t("otpPasswordModal.cancel")}
                </GreenLabel>

                <ActionButton width="25%" type="submit">
                  {t("otpPasswordModal.continue")}
                </ActionButton>
              </div>
            </Form>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default OtpPasswordModal;
